import React from 'react';
import { type Merchant } from '../../core/model/merchant';
import './Receiver.css';
import defaultMerchant from './merchant.svg';
import { PaymentType } from '../../core/context/claims';

interface Props {
  merchant: Merchant;
  paymentType: PaymentType;
}

function Receiver({ merchant, paymentType }: Props): React.ReactNode {
  const { companyName, displayName } = merchant;
  const logoUrl = merchant.logoUrl ? merchant.logoUrl : defaultMerchant;
  let legalName;

  const addDefaultSrc: React.ReactEventHandler<HTMLImageElement> = (ev) => {
    (ev.target as HTMLImageElement).src = defaultMerchant;
  };

  if (paymentType !== PaymentType.PSP_PAYMENT) {
    legalName = companyName;
  }

  return (
    <div className="receiver">
      <div className="merchant-logo">
        {/* Image is decorative — identity is announced by the displayName beside it. */}
        <img src={logoUrl} onError={addDefaultSrc} alt="" aria-hidden="true" />
      </div>
      <div className="labels">
        <p className="display-name">{displayName}</p>
        <p className="legal-name">{legalName}</p>
      </div>
    </div>
  );
}

export default Receiver;
